import {motion,useMotionValue,useSpring,useTransform} from 'framer-motion';

function TiltCard({children, className = ''}) {
  const px = useMotionValue(0);
  const py = useMotionValue(0);
  const rx = useSpring(useTransform(py, [-0.5, 0.5], [9, -9]), {stiffness: 200, damping: 18});
  const ry = useSpring(useTransform(px, [-0.5, 0.5], [-9, 9]), {stiffness: 200, damping: 18});

  const move = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    px.set((e.clientX - r.left) / r.width - 0.5);
    py.set((e.clientY - r.top) / r.height - 0.5);
  };
  const leave = () => {
    px.set(0);
    py.set(0);
  };

  return (
    <motion.div
      onMouseMove={move}
      onMouseLeave={leave}
      style={{rotateX: rx, rotateY: ry, transformPerspective: 900}}
      whileHover={{scale: 1.03}}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export default TiltCard;
